import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import { ContactItem } from "./contact-item/contact-item";
import classes from "./contact.module.css";

export const Contact = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<section className={classes.contact} id="contact">
			<ContactItem
				texts={[atob(texts.contact.phone)]}
				icon="/icons/contact/phone.svg"
				onClick={() =>
					(window.location.href = `tel:${atob(texts.contact.phone)}`)
				}
			/>
			<ContactItem
				texts={texts.contact.address}
				icon="/icons/contact/gps.svg"
				href="https://goo.gl/maps/VYYATdiNeh9efdPK6"
			/>
			<ContactItem
				texts={[atob(texts.contact.email)]}
				icon="/icons/contact/mail.svg"
				onClick={() =>
					(window.location.href = `mailto:${atob(texts.contact.email)}`)
				}
			/>
		</section>
	);
};
